/** Steps of the order flow, in order, shown in the Cart -> Address -> Payment progress indicator. */
export enum OrderFlowStep {
  CART = 'cart',
  ADDRESS = 'address',
  PAYMENT = 'payment',
}

/** Visual state of a single step relative to the currently active step. */
export enum OrderFlowStepState {
  COMPLETED = 'completed',
  ACTIVE = 'active',
  PENDING = 'pending',
}
